import type { JSX } from '@familyjs/core/components';
import { defineCustomElement } from '@familyjs/core/components/fml-loading.js';

import { createInlineOverlayComponent } from './createInlineOverlayComponent';

export const FmlLoading = /*@__PURE__*/ createInlineOverlayComponent<JSX.FmlLoading, HTMLFmlLoadingElement>(
  'fml-loading',
  defineCustomElement
);
